// Custom Personalisierung Geldschein 100USD JavaScript
(function() {
    'use strict';

    // Da Pflichtfelder und Zeichenbeschränkungen drin sind, muss das Formular valide sein bzw. die Validierung aktiviert werden:
    // Form validation - remove novalidate attribute
    function enableFormValidation() {
        const form = document.querySelector("form[novalidate]");
        if (form) {
            form.removeAttribute("novalidate");
        }
    }

    function createCustomMagnify(imageElement, zoomRatio = 2) {
        // Create overlay
        const overlay = document.createElement('div');
        overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        z-index: 10000;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: zoom-out;
    `;

        // Create magnified image container
        const magnifiedContainer = document.createElement('div');
        magnifiedContainer.style.cssText = `
        position: relative;
        max-width: 90vw;
        max-height: 90vh;
        overflow: hidden;
        border-radius: 8px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    `;

        // Create magnified image
        const magnifiedImage = document.createElement('img');
        magnifiedImage.src = imageElement.src;
        magnifiedImage.alt = imageElement.alt || 'Vergrößerte Vorschau';
        magnifiedImage.style.cssText = `
        display: block;
        max-width: 100%;
        max-height: 90vh;
        object-fit: contain;
        width: ${imageElement.naturalWidth * Math.min(zoomRatio, 3)}px;
        height: ${imageElement.naturalHeight * Math.min(zoomRatio, 3)}px;
        transition: transform 0.1s ease-out;
    `;

        // Create close button
        const closeButton = document.createElement('button');
        closeButton.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
    `;
        closeButton.style.cssText = `
        position: absolute;
        top: 20px;
        right: 20px;
        background: rgba(0, 0, 0, 0.6);
        border: none;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 10001;
        transition: background-color 0.2s ease;
    `;

        closeButton.addEventListener('mouseenter', () => {
            closeButton.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
        });

        closeButton.addEventListener('mouseleave', () => {
            closeButton.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
        });

        // Assembly
        magnifiedContainer.appendChild(magnifiedImage);
        overlay.appendChild(magnifiedContainer);
        overlay.appendChild(closeButton);

        // Variables for panning
        let isDragging = false;
        let startX, startY, translateX = 0, translateY = 0;

        // Close functionality
        const closeOverlay = () => {
            overlay.remove();
            document.body.style.overflow = '';
        };

        // Event listeners
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) {
                closeOverlay();
            }
        });

        closeButton.addEventListener('click', closeOverlay);
        magnifiedImage.addEventListener('click', closeOverlay);

        // ESC key to close
        const escapeHandler = (e) => {
            if (e.key === 'Escape') {
                closeOverlay();
                document.removeEventListener('keydown', escapeHandler);
            }
        };
        document.addEventListener('keydown', escapeHandler);

        // Panning functionality for large images
        if (magnifiedImage.offsetWidth > window.innerWidth * 0.9 ||
            magnifiedImage.offsetHeight > window.innerHeight * 0.9) {

            magnifiedImage.addEventListener('mousedown', (e) => {
                isDragging = true;
                startX = e.clientX - translateX;
                startY = e.clientY - translateY;
                magnifiedImage.style.cursor = 'grabbing';
                e.preventDefault();
            });

            document.addEventListener('mousemove', (e) => {
                if (!isDragging) return;

                translateX = e.clientX - startX;
                translateY = e.clientY - startY;

                // Constrain movement
                const containerRect = magnifiedContainer.getBoundingClientRect();
                const imageRect = magnifiedImage.getBoundingClientRect();

                const maxTranslateX = Math.max(0, (imageRect.width - containerRect.width) / 2);
                const maxTranslateY = Math.max(0, (imageRect.height - containerRect.height) / 2);

                translateX = Math.max(-maxTranslateX, Math.min(maxTranslateX, translateX));
                translateY = Math.max(-maxTranslateY, Math.min(maxTranslateY, translateY));

                magnifiedImage.style.transform = `translate(${translateX}px, ${translateY}px)`;
            });

            document.addEventListener('mouseup', () => {
                isDragging = false;
                magnifiedImage.style.cursor = 'move';
            });
        }

        // Add to page and prevent body scrolling
        document.body.style.overflow = 'hidden';
        document.body.appendChild(overlay);

        // Focus the overlay for accessibility
        overlay.focus();
    }


    // Preview generation functionality
    // Preview generation functionality (fixed image display)
    function initPreviewGeneration(personalisierungstyp) {
        const btn = document.getElementById('button-preview-generieren');
        const img = document.getElementById('preview-image');
        const placeholder = document.querySelector('.preview-placeholder');
        const imageWrapper = document.querySelector('.preview-image-wrapper');
        const hiddenPreviewIdInput = document.getElementById('previewId');

        if (!btn) return;

        // Function to add magnify functionality to the image using Dawn's system
        function addMagnifyToImage(imageElement) {
            // Wait for image to load to get proper dimensions
            imageElement.onload = function() {
                const naturalWidth = imageElement.naturalWidth;
                const naturalHeight = imageElement.naturalHeight;

                console.log('Image dimensions:', { naturalWidth, naturalHeight });

                // Only add magnify if the image is reasonably sized
                if (naturalWidth >= 200 || naturalHeight >= 200) {

                    // Calculate zoom ratio based on image size
                    let zoomRatio = 2; // default zoom

                    if (naturalWidth >= 1000 || naturalHeight >= 1000) {
                        zoomRatio = 3; // high zoom for large images
                    } else if (naturalWidth >= 500 || naturalHeight >= 500) {
                        zoomRatio = 2.5; // medium zoom for medium images
                    } else {
                        zoomRatio = 2; // standard zoom for smaller images
                    }

                    console.log('Adding Dawn magnify with zoom ratio:', zoomRatio);

                    // Add magnify functionality
                    imageElement.classList.add('magnify-enabled');
                    imageElement.style.cursor = 'zoom-in';

                    // Clean up any existing event listeners
                    const newImage = imageElement.cloneNode(true);
                    imageElement.parentNode.replaceChild(newImage, imageElement);

                    // Add click event for Dawn's magnify
                    newImage.addEventListener('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        console.log('Image clicked, calling Dawn magnify');
                        try {
                            createCustomMagnify(newImage, zoomRatio);
                        } catch (error) {
                            console.error('Error calling custom magnify:', error);
                        }
                    });
                    // Update the reference to point to the new image
                    return newImage;

                } else {
                    // Image is too small to magnify meaningfully
                    imageElement.style.cursor = 'default';
                    imageElement.classList.remove('magnify-enabled');
                    return imageElement;

                }
            };

            // If image is already loaded, trigger onload manually
            if (imageElement.complete && imageElement.naturalWidth > 0) {
                imageElement.onload();
            }
            return imageElement;

        }

        function setLoading(loading) {
            const btnText = btn.querySelector('.preview-btn-text');
            const spinner = btn.querySelector('.preview-loading-spinner');

            if (loading) {
                btn.disabled = true;
                btn.classList.add('loading');
                if (spinner) {
                    spinner.classList.remove('hidden');
                }
                if (btnText) {
                    btnText.textContent = 'Vorschau wird erstellt …';
                }
            } else {
                const fileInput = document.getElementById('file-bild');
                const hasFile = !!(fileInput && fileInput.files && fileInput.files.length === 1);
                btn.disabled = !hasFile;
                btn.classList.remove('loading');
                if (spinner) {
                    spinner.classList.add('hidden');
                }
                if (btnText) {
                    btnText.textContent = 'Vorschau erzeugen';
                }
            }
        }

        btn.addEventListener('click', async (e) => {
            e.preventDefault();

            // Reset image state
            if (img) {
                img.removeAttribute('src');
                img.classList.remove('magnify-enabled');
                img.style.cursor = 'default';
            }

            // Show placeholder, hide image wrapper
            if (placeholder) {
                placeholder.style.display = 'block';
            }

            if (imageWrapper) {
                imageWrapper.style.display = 'none';
            }

            const fileInput = document.getElementById('file-bild');
            const textzeile1 = document.getElementById('textzeile1')?.value || '';
            const textzeile2 = document.getElementById('textzeile2')?.value || '';
            const textzeile3 = document.getElementById('textzeile3')?.value || '';

            if (!fileInput || !fileInput.files || fileInput.files.length !== 1) {
                showErrorModal('Bitte laden Sie genau ein Bild hoch.');
                return;
            }

            setLoading(true);
            const host = 'https://geschenk.jollybooks.de';

            try {
                const formData = new FormData();
                formData.append('textzeile1', textzeile1);
                formData.append('textzeile2', textzeile2);
                formData.append('textzeile3', textzeile3);
                formData.append('personalisierungsTyp', personalisierungstyp);
                formData.append('file', fileInput.files[0]);

                const createRes = await fetch(
                    `${host}/api/personalisierungen/geldschein/preview`,
                    {
                        method: 'POST',
                        body: formData,
                    }
                );

                if (!createRes.ok) {
                    showErrorModal('Fehler bei der Erstellung der Vorschau. Bitte versuchen Sie es erneut.');
                    return;
                }

                const createData = await createRes.json();
                const previewId = createData.previewId;
                if (!previewId) {
                    showErrorModal('Die Vorschau kann nicht abgerufen werden. Bitte versuchen Sie es erneut.');
                    return;
                }

                if (hiddenPreviewIdInput) {
                    hiddenPreviewIdInput.value = previewId;
                }

                const pathParamsEmbeddedVar = JSON.stringify({
                    previewId: previewId,
                });

                const queryParams = new URLSearchParams({
                    pathParamsEmbedded: pathParamsEmbeddedVar,
                    requestId: "11819d50-9917-11f0-ad11-77c5bc659f34",
                });

                const imgResult = await fetch('/apps/apiease/integration/caller/call?' + queryParams).then(function (response) {
                    return response.json();
                });

                if (imgResult.status !== 200) {
                    showErrorModal('Die Vorschau kann nicht geladen werden. Bitte versuchen Sie es erneut.');
                    return;
                }

                const rawText = imgResult.data;
                let dataUrl;

                if (rawText.startsWith('data:')) {
                    dataUrl = rawText;
                } else {
                    const fallbackMime = 'image/png';
                    dataUrl = `data:${fallbackMime};base64,${rawText}`;
                }

                // Get fresh reference to image element
                const finalImg = document.getElementById('preview-image');
                if (finalImg && dataUrl) {
                    console.log('Setting image src and showing wrapper');

                    // Set the image source
                    finalImg.src = dataUrl;

                    // Hide placeholder and show image wrapper
                    if (placeholder) {
                        placeholder.style.display = 'none';
                    }

                    if (imageWrapper) {
                        imageWrapper.style.display = 'flex'; // Changed to flex to maintain centering
                    }

                    // Add magnify functionality after a short delay
                    setTimeout(() => {
                        addMagnifyToImage(finalImg);
                    }, 100);
                }
            } catch (err) {
                showErrorModal(err?.message || 'Unbekannter Fehler bei der Vorschau. Bitte versuchen Sie es erneut.');
            } finally {
                setLoading(false);
            }
        });
    }




    // Button state management for preview and buy buttons
    // In diesem Script-Teil wird der Preview- und der Kaufen-Button aktiviert oder deaktiviert.
    // Der Kunde muss zwingend ein Bild hochladen, damit eine Vorschau generiert oder der Artikel
    // bestellt werden kann.
    function initButtonStateManagement(sectionId) {
        const btn = document.getElementById('button-preview-generieren');
        const buyButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
        const fileInput = document.getElementById('file-bild');
        
        if (!btn || !fileInput) return;

        const syncBtnState = () => {
            const hasFile = fileInput.files && fileInput.files.length === 1;
            btn.disabled = !hasFile;
            if (buyButton) {
                buyButton.disabled = !hasFile;
            }
        };

        // Initial state
        syncBtnState();

        // Update on user interaction
        fileInput.addEventListener('change', syncBtnState);
        fileInput.addEventListener('input', syncBtnState);

        // In case other scripts programmatically clear the input's value
        const observer = new MutationObserver(syncBtnState);
        observer.observe(fileInput, {attributes: true, attributeFilter: ['value']});
    }

    // Preview ID reset functionality
    // Die Preview-ID wird als Referenz bei der Druckdatenerstellung mitgegeben.
    // Wird eines der Eingabefelder jedoch nachträglich verändert und keine neue Vorschau generiert,
    // dann wird das Feld zurückgesetzt. Der Kunde hat in dem Fall korrigiert und direkt bestellt
    // ohne sich eine neue Vorschau generiert zu haben.
    // Daher wird die Preview ID zurückgesetzt, damit nicht eine falsche Referenz zu den
    // Druckdaten kopiert wird.
    function initPreviewIdReset() {
        const textzeile1Input = document.getElementById('textzeile1');
        const textzeile2Input = document.getElementById('textzeile2');
        const textzeile3Input = document.getElementById('textzeile3');
        const bildInput = document.getElementById('file-bild');
        const previewIdInput = document.getElementById('previewId');

        if (!textzeile1Input || !textzeile2Input || !textzeile3Input || !bildInput || !previewIdInput) return;

        const resetPreviewId = () => {
            previewIdInput.value = '';
        };

        textzeile1Input.addEventListener('change', resetPreviewId);
        textzeile2Input.addEventListener('change', resetPreviewId);
        textzeile3Input.addEventListener('change', resetPreviewId);
        bildInput.addEventListener('change', resetPreviewId);
    }


    // Function to show error in a centered, properly sized modal
    function showErrorModal(message) {
        // Create modal HTML with better sizing
        const modalHtml = `
        <details-modal class="error-modal">
            <details open>
                <summary style="display: none;"></summary>
                <div class="modal__content" role="dialog" aria-modal="true" style="
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.5);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 1000;
                ">
                    <div class="modal__content-inner" tabindex="-1" style="
                        width: 90%;
                        max-width: 500px;
                        max-height: 90vh;
                        background: rgb(var(--color-background));
                        color: rgb(var(--color-foreground));
                        border-radius: 8px;
                        padding: 2rem;
                        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
                        position: relative;
                        overflow-y: auto;
                    ">
                        <button type="button" class="modal__close-button" style="
                            position: absolute;
                            top: 1rem;
                            right: 1rem;
                            background: none;
                            border: none;
                            font-size: 1.5rem;
                            cursor: pointer;
                            color: rgb(var(--color-foreground));
                            padding: 0.5rem;
                            line-height: 1;
                        " aria-label="Schließen">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path d="m1.5 1.5 15 15m-15 0 15-15" stroke="currentColor" stroke-width="2"/>
                            </svg>
                        </button>
                        
                        <div style="text-align: center;">
                            <div style="color: rgb(var(--color-error, 215 44 13)); margin-bottom: 1.5rem;">
                                <svg width="64" height="64" viewBox="0 0 24 24" fill="currentColor" style="display: block; margin: 0 auto;">
                                    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
                                </svg>
                            </div>
                            <h2 style="margin-bottom: 1rem; font-size: 1.5rem; font-weight: 600;">Fehler</h2>
                            <p style="margin-bottom: 2rem; line-height: 1.5; color: rgb(var(--color-foreground));">${message}</p>
                            <button type="button" class="button button--primary error-modal-ok" style="min-width: 120px;">OK</button>
                        </div>
                    </div>
                </div>
            </details>
        </details-modal>
    `;

        // Remove existing error modal if any
        const existingModal = document.querySelector('.error-modal');
        if (existingModal) {
            existingModal.remove();
        }

        // Add modal to page
        document.body.insertAdjacentHTML('beforeend', modalHtml);

        // Get the modal element (after it's added to DOM)
        const modal = document.querySelector('.error-modal');
        const modalContent = modal.querySelector('.modal__content');

        // Define close function
        const closeModal = () => {
            if (modal && modal.parentNode) {
                modal.remove();
            }
            // Remove focus trap
            document.body.style.overflow = '';
        };

        // Get buttons after modal is in DOM
        const closeButton = modal.querySelector('.modal__close-button');
        const okButton = modal.querySelector('.error-modal-ok');

        // Add event listeners
        if (closeButton) {
            closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                closeModal();
            });
        }

        if (okButton) {
            okButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                closeModal();
            });
        }

        // Close on backdrop click
        if (modalContent) {
            modalContent.addEventListener('click', (e) => {
                if (e.target === modalContent) {
                    closeModal();
                }
            });
        }

        // Close on Escape key
        document.addEventListener('keyup', function escapeHandler(event) {
            if (event.code.toUpperCase() === 'ESCAPE') {
                closeModal();
                document.removeEventListener('keyup', escapeHandler);
            }
        });

        // Prevent body scrolling
        document.body.style.overflow = 'hidden';

        // Focus the modal
        setTimeout(() => {
            const focusTarget = modal.querySelector('[tabindex="-1"]');
            if (focusTarget) {
                focusTarget.focus();
            }
        }, 100);
    }


    // Export functions to global scope
    window.PersonalizationGeldschein = {
        enableFormValidation: enableFormValidation,
        initPreviewGeneration: initPreviewGeneration,
        initButtonStateManagement: initButtonStateManagement,
        initPreviewIdReset: initPreviewIdReset,
        showErrorModal: showErrorModal
    };
})();
